<script lang="ts">
  import { getContext } from 'svelte'
  import type { HTMLAttributes } from 'svelte/elements'

  type Props = HTMLAttributes<HTMLDivElement> & {
    value: string
  }

  const { children, value, class: className, ...rest }: Props = $props()

  const { selected } = getContext('tabs') as TabContext

</script>

{#if $selected === value}
  <div
    class={`container ${className}`}
    data-selected={$selected === value}
    {...rest}
  >
    {@render children?.()}
  </div>
{/if}

<style lang="scss">
  .container {
    display: none;
    flex: 1;
    overflow: hidden;

    &[data-selected="true"] {
      display: flex;
    }
  }
</style>
